import { motion } from "framer-motion";
import { ShinyButton } from "@/components/ui/ShinyButton";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTA() {
  const navigate = useNavigate();
  return (
    <section id="get-started" data-testid="cta-section" className="relative overflow-hidden py-28 lg:py-40">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[560px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse,rgba(255,159,28,0.12),transparent_65%)]" />
        <div className="absolute inset-0 opacity-[0.35]" style={{ backgroundImage: "linear-gradient(color-mix(in srgb, var(--pq-text1) 5%, transparent) 1px, transparent 1px), linear-gradient(90deg, color-mix(in srgb, var(--pq-text1) 5%, transparent) 1px, transparent 1px)", backgroundSize: "72px 72px" }} />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ type: "spring", stiffness: 100, damping: 20 }}
        className="relative mx-auto max-w-3xl px-6 text-center"
      >
        <p className="mb-5 flex items-center justify-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-amber-500">
          <span className="h-px w-10 bg-amber-500" />
          Get Started
          <span className="h-px w-10 bg-amber-500" />
        </p>
        <h2 className="font-display text-5xl font-semibold tracking-tighter sm:text-6xl lg:text-7xl">
          Stock Up. <span className="text-amber-500">Stay Ready.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-2 lg:text-lg">
          Everything you need to pack, ship and run your business — sourced, stocked and ready to go.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <ShinyButton
            data-testid="cta-start-shopping-btn"
            onClick={() => navigate("/shop")}
            className="transition-transform duration-300 hover:scale-[1.03]"
            contentClassName="px-8 py-4 text-sm font-bold"
          >
            Shop PAQVERO
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </ShinyButton>
          <ShinyButton
            data-testid="cta-explore-products-btn"
            onClick={() => navigate("/shop")}
            className="transition-transform duration-300 hover:scale-[1.03]"
            contentClassName="px-8 py-4 text-sm font-bold"
          >
            Explore Products
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </ShinyButton>
        </div>
      </motion.div>
    </section>
  );
}
